import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import Reveal, { Eyebrow } from "../common/Reveal";
import { programCards, BOOK_URL } from "../../mock";

export default function Programs() {
  return (
    <section className="bg-lybl-paper py-20 lg:py-28">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="text-center">
          <Reveal><Eyebrow>{programCards.eyebrow}</Eyebrow></Reveal>
          <Reveal delay={80}><h2 className="mt-4 font-serif text-4xl lg:text-5xl text-lybl-ink">{programCards.title}</h2></Reveal>
          <Reveal delay={140}><p className="mt-5 max-w-2xl mx-auto text-lybl-muted text-lg">{programCards.subtitle}</p></Reveal>
        </div>

        <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {programCards.cards.map((c, i) => (
            <Reveal key={c.title} delay={(i % 3) * 70}>
              <Link to={c.to} className="group block h-full rounded-2xl bg-white ring-1 ring-black/5 p-5 hover:shadow-lg hover:ring-lybl-green/20 transition-all">
                <div className="flex items-start justify-between gap-4">
                  <div>
                    <h3 className="font-serif text-xl text-lybl-ink">{c.title}</h3>
                    <p className="mt-2 text-[14px] text-lybl-muted leading-relaxed group-hover:hidden">{c.desc}</p>
                    <p className="mt-2 text-[14px] text-lybl-green leading-relaxed hidden group-hover:block">{c.hover}</p>
                  </div>
                  <img src={c.image} alt="" className="h-14 w-14 object-contain shrink-0" />
                </div>
                <span className="mt-4 inline-flex items-center gap-1 text-[14px] font-medium text-lybl-rust">
                  Explore <ChevronRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
                </span>
              </Link>
            </Reveal>
          ))}
        </div>

        <Reveal delay={120}>
          <div className="mt-14 overflow-hidden rounded-3xl bg-lybl-green px-8 py-12 lg:px-14 lg:py-14 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8">
            <div className="max-w-xl">
              <p className="text-[13px] font-semibold uppercase tracking-[0.18em] text-white/60">Let's Talk</p>
              <h3 className="mt-3 font-serif text-3xl lg:text-4xl text-white">Don't see what you're looking for?</h3>
              <p className="mt-4 text-white/75 text-[15px]">We support 120+ health concerns, with every plan built around you. Start with a free consultation to receive your personalized plan.</p>
            </div>
            <a href={BOOK_URL} target="_blank" rel="noreferrer" data-evt="schedule" className="shrink-0 inline-flex items-center gap-2 rounded-full bg-white px-7 py-4 text-[15px] font-medium text-lybl-green hover:bg-lybl-cream transition-colors">
              Schedule Your Consult <span aria-hidden>→</span>
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
